"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TechnicalProjectStatus = void 0;
var TechnicalProjectStatus;
(function (TechnicalProjectStatus) {
    TechnicalProjectStatus["WIP"] = "work-in-progress";
    TechnicalProjectStatus["AWAIT_PSI"] = "await-psi";
    TechnicalProjectStatus["AWAIT_PASSPORT"] = "await-passport";
    TechnicalProjectStatus["ARCHIVE"] = "archive";
})(TechnicalProjectStatus = exports.TechnicalProjectStatus || (exports.TechnicalProjectStatus = {}));
//# sourceMappingURL=technical-project.status.js.map